import React from "react";
import { IMAGES } from "../lib/site";
import WaitlistForm from "../components/site/WaitlistForm";

export default function Waitlist() {
  return (
    <div data-testid="waitlist-page" className="pt-20">
      <section className="relative min-h-[80vh] flex items-center overflow-hidden">
        <img src={IMAGES.selfcare} alt="Waitlist" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-matte/70" />
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 py-24 grid md:grid-cols-2 gap-16 items-center w-full">
          <div className="text-ivory">
            <div className="text-[11px] uppercase tracking-luxe text-gold mb-6">The Waitlist</div>
            <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">Be first to experience<br/><span className="italic text-gold">Crowned Essence.</span></h1>
            <p className="mt-8 text-lg text-ivory/80 font-light max-w-lg">Join our community and be the first to know when we launch. Waitlist members receive founding-tier pricing and exclusive box editions.</p>
            <ul className="mt-8 space-y-3 text-ivory/80">
              <li className="flex gap-3"><span className="text-gold">◆</span> Early access at launch</li>
              <li className="flex gap-3"><span className="text-gold">◆</span> Founding-tier pricing</li>
              <li className="flex gap-3"><span className="text-gold">◆</span> Exclusive editions & drops</li>
            </ul>
          </div>
          <div>
            <div className="bg-ivory p-8 md:p-12">
              <div className="text-[11px] uppercase tracking-luxe text-gold mb-4">Reserve Your Seat</div>
              <div className="font-serif text-3xl mb-8 leading-tight">Every crown starts <span className="italic">here.</span></div>
              <WaitlistForm variant="light" testIdPrefix="page-waitlist" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
